export enum ServiceQueueActionType {
  FETCH_SERVICE_QUEUES = "FETCH_SERVICE_QUEUES",
  FETCH_SERVICE_QUEUE_REQUEST = "FETCH_SERVICE_QUEUE_REQUEST",
  FETCH_SERVICE_QUEUE_SUCCESS = "FETCH_SERVICE_QUEUE_SUCCESS",
  FETCH_SERVICE_QUEUE_ERROR = "FETCH_SERVICE_QUEUE_ERROR",
}
